import API from "api/api/API";
import Cookies from "js-cookie";
import TenantAPI from "./TenantAPI";

export default class CloudAppAPI {
  static getTokenForSupportalSupportedEndpoints(tenantID) {
    return tenantID
      ? Cookies.get("authenticationToken")
      : Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`);
  }

  static async createCloudAppFromFolder(workspaceID, folderID, payload) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/apps/folders/${folderID}`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async installCloudApp(workspaceID, appID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/apps/${appID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async uninstallCloudApp(workspaceID, appID) {
    return API._bearerRequest(
      "delete",
      `/tenant/workspaces/${workspaceID}/apps/${appID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getAllCloudApps(workspaceID, cloudID) {
    return API._bearerRequest(
      "get",
      `/tenant/cloud/workspaces/${workspaceID || cloudID}/apps${
        cloudID ? `?tenantID=${cloudID}` : ""
      }`,
      null,
      this.getTokenForSupportalSupportedEndpoints(cloudID)
    );
  }

  static async getCloudAppByID(appID, workspaceID) {
    return API._bearerRequest(
      "get",
      `/tenant/cloud/workspaces/${workspaceID}/apps/${appID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async createCloudApp(payload, workspaceID) {
    return API._bearerRequest(
      "post",
      `/tenant/cloud/workspaces/${workspaceID}/apps`,
      { payload, workspaceID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async modifyCloudApp(appID, payload, workspaceID) {
    return API._bearerRequest(
      "put",
      `/tenant/cloud/workspaces/${workspaceID}/apps/${appID}`,
      { payload, workspaceID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async unpublishCloudApp(appID, workspaceID) {
    return API._bearerRequest(
      "delete",
      `/tenant/cloud/workspaces/${workspaceID}/apps/${appID}`,
      { workspaceID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async copyCloudAppToAnotherCloud(fromCloudID, toCloudID, cloudAppID) {
    return API._bearerRequest(
      "post",
      `/tenant/cloud/workspaces/copy/${fromCloudID}/to/${toCloudID}/app/${cloudAppID}`,
      null,
      Cookies.get(`authenticationToken`)
    );
  }

  static async addExistingPageinCloudApp(cloudAppID, workspaceID, pageIds) {
    return API._bearerRequest(
      "put",
      `/tenant/cloud/workspaces/${workspaceID}/apps/${cloudAppID}/pages`,
      {
        pageIds,
      },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
